var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "Card",
        [
          _c(
            "transition",
            { attrs: { name: "fade" } },
            [
              _vm.mainTable.sarchCardShow
                ? _c(
                    "Row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "Col",
                        { attrs: { span: "24" } },
                        [
                          _c("search-card", {
                            attrs: {
                              form: _vm.mainTable.searchForm,
                              "table-load-event": _vm.getMainTableRecords,
                              "table-search": _vm.mainTable.tableSearch,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c("Col", { attrs: { span: "24" } }, [
                _c("div", { staticClass: "global-tool-bar" }, [
                  _c("div", { staticClass: "left-bar" }, [
                    _c("span", { staticClass: "title" }, [
                      _vm._v("存货仓管理"),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "right-bar" },
                    [
                      _vm.$checkAccessArray(["H"])
                        ? _c(
                            "Button",
                            {
                              staticClass: "btns",
                              attrs: {
                                size: "small",
                                shape: "circle",
                                type: "success",
                                icon: "ios-add-circle-outline",
                              },
                              on: { click: _vm.onCreate },
                            },
                            [_vm._v("新增")]
                          )
                        : _vm._e(),
                      _c(
                        "Button",
                        {
                          staticClass: "btns",
                          attrs: {
                            type: "primary",
                            size: "small",
                            shape: "circle",
                            icon: "ios-search",
                          },
                          on: {
                            click: function ($event) {
                              _vm.mainTable.sarchCardShow =
                                !_vm.mainTable.sarchCardShow
                            },
                          },
                        },
                        [_vm._v("搜索")]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "Row",
            { staticClass: "row-margin-top-10", attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c("stand-pagination-table", {
                    attrs: {
                      columns: _vm.mainTable.tableColumns,
                      data: _vm.mainTable.tableData,
                      loading: _vm.mainTable.tableLoading,
                      "table-search": _vm.mainTable.tableSearch,
                      "table-load-event": _vm.getMainTableRecords,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "Modal",
        {
          attrs: { title: "仓库信息" },
          model: {
            value: _vm.formShow,
            callback: function ($$v) {
              _vm.formShow = $$v
            },
            expression: "formShow",
          },
        },
        [
          _c(
            "Form",
            {
              ref: "warehouseForm",
              staticClass: "small-form border",
              attrs: {
                model: _vm.form,
                rules: _vm.ruleValidate,
                "label-position": "top",
              },
            },
            [
              _c(
                "Row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        {
                          attrs: { label: "存货仓名称", prop: "warehouseName" },
                        },
                        [
                          _c("Input", {
                            model: {
                              value: _vm.form.warehouseName,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "warehouseName", $$v)
                              },
                              expression: "form.warehouseName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        {
                          attrs: { label: "负责人", prop: "warehouseContacts" },
                        },
                        [
                          _c("Input", {
                            model: {
                              value: _vm.form.warehouseContacts,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "warehouseContacts", $$v)
                              },
                              expression: "form.warehouseContacts",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "手机", prop: "warehousePhone" } },
                        [
                          _c("Input", {
                            model: {
                              value: _vm.form.warehousePhone,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "warehousePhone", $$v)
                              },
                              expression: "form.warehousePhone",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "存货仓地址" } },
                        [
                          _c("Input", {
                            model: {
                              value: _vm.form.warehouseAddress,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "warehouseAddress", $$v)
                              },
                              expression: "form.warehouseAddress",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _vm.$checkAccessArray(["H"])
                ? _c(
                    "Button",
                    { attrs: { type: "primary" }, on: { click: _vm.onSave } },
                    [_vm._v("确认\n            ")]
                  )
                : _vm._e(),
              _c(
                "Button",
                {
                  attrs: { type: "error" },
                  on: {
                    click: function ($event) {
                      _vm.formShow = false
                    },
                  },
                },
                [_vm._v("取消\n            ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }